import React,{  PureComponent, } from 'react'
import {Select, Tooltip, Popconfirm, message, Spin} from 'antd';
import CategorySelect from "../categorySelect/categorySelect"
import { postHttpAction,isEmptyObject,isEmpty } from '@utils/utils';
import Lang from "@components/Lang/Lang";
import './index.less';
import PropTypes from "prop-types";
import _ from "lodash";
const { Option } = Select;

/**
 * 证书规则选择
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 **/
class CertificateRule extends PureComponent {
    static propTypes = {
        changeAttrValues: PropTypes.func, // 修改属性值 方法
        copyRule: PropTypes.func,  // 复制规则
        deleteRule: PropTypes.func, // 删除规则
        attrValues:PropTypes.array, // 属性值列表
    };
    static defaultProps = {
        inxRule:'', // 当前序号
        id:"", // 单号，有此单号会请求接口 显示数据
        ruleType:"1",// 类型 1 匹配 ,2 排除
        attrValues:[],
        selectedCategorySure:{},//已选类目
        pageState:{}, //复制规则时 原规则存在的数据
        submitStatus:""
    };
    constructor(props) {
        super(props);
        this.state = {
            ...props.pageState,
            selectedCategorySure: props.selectedCategorySure||{},
        }
    }
    /*
    * 添加 条件
    * */
    pushAttrList(id){
        const { attrValues =[],inxRule,ruleType }=this.props;
        let newAttrs = [...attrValues]
        newAttrs.push({
            id: id,
            optionType:newAttrs.length==0?"and":"or" ,// 本行规则类型 或 or 且 and,第一行应为且的关系
        })
        this.props.changeAttrValues(ruleType,inxRule,newAttrs)
    }
    deleteAttrList(inx){
        // 删除 父级值列表
        const { attrValues =[],ruleType,inxRule} = this.props;
        let newAttrs = [...attrValues]
        newAttrs.splice(inx,1);
        this.props.changeAttrValues(ruleType,inxRule,newAttrs);
    }
    /**
     * 修改事件
     * @param v 值
     * @param inx 序号
     * @param field 字段
     * @param vObj 值对应对象
     * */
     handleChange(v,inx=0,field="value",vObj) {
         const { attrValues =[], inxRule,ruleType } = this.props;
         let newAttrs = [...attrValues]
            newAttrs[inx][field]= v;
        if(field=="field"){// 选择属性项时，赋值下拉值
            newAttrs[inx]["value"]= [];
            newAttrs[inx]["source"]= vObj; //完整来源对象
        }
        this.props.changeAttrValues(ruleType,inxRule,newAttrs,false)
    }
    IconDelete = (size=24) => {
        return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
                <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 11V13H17V11H7Z" fill="#FF4D4F"/>
            </svg>);
    }
    /*
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 选择类目后
     * 类目属性 http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8035
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8070
     * @param selectedCategorySure  已选 类目对象
     * @param flag 其他更新操作， 需求变更，操作也不清空关联材质属性( 原清空当时所选项，默认操作动作需清空，初始化进入则无则清空)
     * @param  callBack 查询成功后回调
     *
     * */
    selectedCates(selectedCategorySure,flag=true,callBack) {
        // 由于要求 已删除的类目需要显示 ，但保存时要过滤， 增 hadValid为true 才提交
        let cates = [];
        for(let key in selectedCategorySure){
            const item = selectedCategorySure[key]; // 由于要求 已删除的类目需要显示 ，但保存时要过滤， 增 hadValid为true 才提交
            if(item.hadValid){
                cates.push(key);
            }
        }
        if(cates&&cates.length>0){
            this.loading(true);
            postHttpAction('/service/mg/certificate/query-category-att', {
                categoryIds: cates
            }, (resData) => {
                const { success, valid,models=[]} = resData;
                let attributeNamesOptions = [];
                models.forEach((item)=>{
                    attributeNamesOptions.push({
                        value:item.selectKey,
                        label:item.name,
                        item:item
                    })
                })
                if (success &&valid) {
                    if(typeof callBack=="function"){
                        callBack(models);
                    }
                    this.setState({
                        attributeNames:attributeNamesOptions,
                        categoryIds: cates,
                        selectedCategorySure: selectedCategorySure,
                    })
                }else {
                    this.setState({
                        attributeNames:[],
                        categoryIds: [],
                        selectedCategorySure: selectedCategorySure,
                    })
                    if(resData.message){
                        message.warning(resData.message)
                    }
                }
            });
            this.loading(false);
        }else{
            this.setState({
                attributeNames:[],
                categoryIds: [],
                selectedCategorySure: selectedCategorySure,//只是初始化 即时无对应类目也要显示类目
            })
        }
        // 更新其他操作 更新到上级的类目 已选值
        if(flag){
            const { inxRule,ruleType, }=this.props;
            // attrValues.forEach(item=>{ // attrValues=[] 需求变更，操作也不清空关联材质属性
            //     item.field =""
            //     item.value = []
            // })
            // this.props.changeAttrValues(ruleType,inxRule,attrValues,)
            this.props.selectedPageCates(ruleType,inxRule,selectedCategorySure,)
        }
    }
    /*
    * 获取 属性值下拉数据
    * */
    getAttrOption(models = []){
        let attributeValueOptions = [];
        models.forEach((attr)=>{
            attributeValueOptions.push({
                value: attr.isNonAttr==1?attr.optionId:attr.nonAttrCode,
                label: attr.name,
                item: attr
            })
        })
        return attributeValueOptions;
    }
    /*
    * 初始化内容
    * */
    init(){
        const { selectedCategorySure,} = this.props;
       // 进入查询 已选类目可选属性列表  类目可能已不在证书内 ,此时对应属性值已不可靠
        this.selectedCates(selectedCategorySure,false,(attributeNames=[])=>this.initHandle(attributeNames))
    }
    initHandle(attributeNames=[]){
        const { inxRule,ruleType,attrValues} = this.props;
        if(attributeNames.length>0){ // 对应 匹配每个可选属性值 项
            const newList = _.cloneDeep(attrValues);
            let list = []
            newList.forEach((yObj={})=>{
                const curr = attributeNames.find((att={})=>att.selectKey == yObj.field );
                if(curr){ // 如无匹配到属性列表为无效内容不加入显示，匹配到属性但已无对应option项将显示option id,操作人自行处理，若不处理 保存时会忽略不保留
                    yObj["source"] =  curr;
                    list.push(yObj);
                }
            })
            this.props.changeAttrValues(ruleType,inxRule,list,)
        }
    }
    componentWillMount() {
        this.init();
    };
    componentWillUnmount() {
        this.setState = ()=>false;
    }
    render() {
        const {  categoryTree=[],saleGoodsCertificateId, inxRule,ruleType,attrValues=[],submitStatus,hadCategoryDelete }=this.props;
        const {loading=false, attributeNames=[], selectedCategorySure} = this.state;
        return ( <Spin spinning={loading}>
            <div className={"ruleWrap mt_12 black89 font_14"} key={`certRule_${ruleType}_${inxRule}`}>
            <div className={"mb_12 flex-item-between"}>
                <div className={"fw_700"}>
                    {Lang({id: 'GuiZe', default: '规则'})}<span className={"ml_2"}>{inxRule+1}</span>
                </div>
                <div className={"font_12"}>
                    <span className={"ml_2 color-blue cursor-p"} onClick={()=>this.props.copyRule(ruleType,inxRule,this.state)}>
                        {Lang({id: 'FuZhi', default: '复制'})}
                    </span>
                    <Popconfirm title={Lang({id:"ShiFouYaoShanChuTiaoJian",default:"是否要删除条件"})}
                                // okText={Lang({id:"QueDing",default:"确定"})}
                                // cancelText={Lang({id:"QuXiao",default:"取消"})}
                                okText="Yes" cancelText="No"
                                onConfirm={()=>this.props.deleteRule(ruleType,inxRule)}>
                        <span className={"ml_16 color-red2 cursor-p"}>
                            {Lang({id: 'ShanChu', default: '删除'})}</span>
                    </Popconfirm>
                </div>
            </div>
            <div className={"grey mb_12"}>
                <div className={"mb_8"}><span className={"mr_2 color-red2 font_16"}>*</span>{Lang({id:"ShangPinShuYuYiXiaLeiMu",default:"商品属于以下类目"})}</div>
                <CategorySelect selectedCates={(selectedCategorySure)=>this.selectedCates(selectedCategorySure)}//修改了类目
                                saleGoodsCertificateId={saleGoodsCertificateId}
                                categoryTree={categoryTree}
                                supLoading={(flag)=>this.loading(flag)}
                                selectedCategorySure={selectedCategorySure} />
                {(hadCategoryDelete||isEmptyObject(selectedCategorySure))&&submitStatus==1?<div className={"color-red2"}>{Lang({id:"QingXuanZeLeiMu",default:"请选择类目"})}</div>:null}
            </div>
            <div className={"grey"}>
                <div className={"mb_8"}>{Lang({id:"QieFuHeYiXiaShangPinShuXing",default:"且符合以下商品属性（如变更类目后，请检查一下属性条件）"})}</div>
                {attrValues.map((attrVal,attInx)=><div key={inxRule+"_att_"+attrVal.id} className={"mb_12 flex-item-ver-center selectBox"}>
                        <div className={"optionLeft cursor-p"} onClick={()=>this.handleChange(attrVal.optionType=="and"?"or":"and",attInx,"optionType")}>
                            <Tooltip placement="top" title={Lang({id:"DianJiQieHuanTiaoJianZuHeFangShi",default:"点击切换条件组合方式"})}>
                                {attrVal.optionType=="and"?<span className={"leftSpanAnd"}>{Lang({id:"Qie",default:"且"})}</span>:<span className={"leftSpanOr"}>{Lang({id:"Huo",default:"或"})}</span>}
                            </Tooltip>
                        </div>
                        {/* 属性 */}
                        <div className={"ml_4 selectHalf"}>
                            <Select showSearch
                                    value={attrVal.field?(attrVal.field+""):""}
                                    placeholder={Lang({id:"QingXuanZe2",default:"请选择"})}
                                    key={inxRule+"_att_name_"+attrVal.id}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    options={attributeNames}
                                    onChange={(name,option={})=>this.handleChange(name,attInx,"field",option.item)}>
                                {/*{attributeNames.map((attr,inx)=><Option key={"attO_"+inx} value={attr.selectKey}*/}
                                                                        {/*item={attr}>{attr.name}</Option>)}*/}
                            </Select>
                        </div>
                        {/* 多选 属性值 */}
                        <div className={"ml_4 selectHalf"}>
                            <Select showSearch
                                    value={attrVal.value}
                                    placeholder={Lang({id:"QingXuanZe2",default:"请选择"})}
                                    key={inxRule+"_att_value_"+attrVal.id}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    mode="multiple"
                                    options={this.getAttrOption(attrVal.source&&attrVal.source.sourceOptionList)}
                                    onChange={(value)=>this.handleChange(value,attInx,"value")}>
                                {/*{(attrVal.source&&attrVal.source.sourceOptionList||[]).map((attr,inx)=><Option key={inx} value={attr.isNonAttr==1?attr.optionId:attr.nonAttrCode}*/}
                                                                                                          {/*item={attr}>{attr.name}*/}
                                {/*</Option>)}*/}
                            </Select>
                        </div>
                        <Popconfirm title={Lang({id:"ShiFouYaoShanChuTiaoJian",default:"是否要删除条件"})}
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={()=>this.deleteAttrList(attInx)}>
                            <span className={"ml_16 cursor-p"}>{this.IconDelete()}</span>
                        </Popconfirm>
                    </div>)}
                <div className={"btnAdd"} onClick={()=>this.pushAttrList(attrValues.length+1)}>{Lang({id:"TianJiaTiaoJian",default:"添加条件"})}</div>
            </div>
        </div>
        </Spin>);
    }
}

export default CertificateRule;
